// Derive le code departement (= `departements.id` cote base) depuis un code postal francais.
// Regle unique, partagee (evite les `slice(0, 2)` disperses qui cassaient les DOM) :
//   - DOM-TOM  : CP commence par 97 ou 98 -> 3 chiffres (ex. 97190 -> "971", 98800 -> "988").
//   - Corse    : CP commence par 20 -> "201" (Corse-du-Sud, 20000-20199) ou "202" (Haute-Corse,
//                20200-20620). La table `departements` utilise 201/202, PAS "2A"/"2B".
//   - Metropole: 2 chiffres (ex. 75001 -> "75").
// Retourne '' si le code postal est absent/trop court.
export const departementFromCodePostal = (codePostal?: string | null): string => {
  if (!codePostal) return '';
  const cp = String(codePostal).trim();
  if (cp.length < 2) return '';

  if (cp.startsWith('97') || cp.startsWith('98')) return cp.slice(0, 3);

  if (cp.startsWith('20')) {
    const n = parseInt(cp.slice(0, 5), 10);
    return !Number.isNaN(n) && n < 20200 ? '201' : '202';
  }

  return cp.slice(0, 2);
};
